export const theme = {
  textTransform: Styles.textTransform.headlines,
};
